__turbopack_context__.v({
  "hero": "doctorHero-module-scss-module__OEfvtW__hero",
  "heroBodyText": "doctorHero-module-scss-module__OEfvtW__heroBodyText",
  "heroBox": "doctorHero-module-scss-module__OEfvtW__heroBox",
  "heroButton": "doctorHero-module-scss-module__OEfvtW__heroButton",
  "heroContent": "doctorHero-module-scss-module__OEfvtW__heroContent",
  "heroFlex": "doctorHero-module-scss-module__OEfvtW__heroFlex",
  "heroImageBigDesktop": "doctorHero-module-scss-module__OEfvtW__heroImageBigDesktop",
  "heroImageDesktop": "doctorHero-module-scss-module__OEfvtW__heroImageDesktop",
  "heroImagePhone": "doctorHero-module-scss-module__OEfvtW__heroImagePhone",
  "heroImageTablet": "doctorHero-module-scss-module__OEfvtW__heroImageTablet",
  "heroTextAlign": "doctorHero-module-scss-module__OEfvtW__heroTextAlign",
  "heroTitle": "doctorHero-module-scss-module__OEfvtW__heroTitle",
  "heroTitleBox": "doctorHero-module-scss-module__OEfvtW__heroTitleBox",
});
